import { render, staticRenderFns } from "./NoDataFound.vue?vue&type=template&id=ea3bb632&scoped=true&"
import script from "./NoDataFound.vue?vue&type=script&lang=js&"
export * from "./NoDataFound.vue?vue&type=script&lang=js&"
import style0 from "./NoDataFound.vue?vue&type=style&index=0&id=ea3bb632&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea3bb632",
  null
  
)

export default component.exports